import React from 'react'
import TeamRegistrationHomeNavigation from './TeamRegistrationHomeNavigation'
import TeamRegistrationUpdate from '../../schedule/TeamRegistrationUpdate'
import RegistrationPageGuard from '../../schedule/RegistrationPageGuard'

const TeamRegistrationUpdateHome = () => {
	return (
		<RegistrationPageGuard navigation={<TeamRegistrationHomeNavigation />}>
			<TeamRegistrationUpdate />
		</RegistrationPageGuard>
	)
}

export default TeamRegistrationUpdateHome
